import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "table"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
export default {
  __name: 'tableTwo',
  props: {
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Number,
      default: []
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return __props.data && __props.data.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: __props.data,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "title",
          label: "主体资质",
          width: "266"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", {
            class: "custom-cell",
            innerHTML: row.title
          }, null, 8, _hoisted_2)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "des",
          label: "详细描述"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", {
            class: "custom-cell",
            innerHTML: row.des
          }, null, 8, _hoisted_3)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])) : _createCommentVNode("", true);
    };
  }
};